/* eslint-disable */
export default function changePasswordValidation(e, msgContainer, key) {
    msgContainer[key] = [];
    msgContainer['isError'] = false;
    let insertedPassword = e.target.value;
    // let res1 =  /^[a-zA-Z()_ \-\[\]'\\|,.\/]*$/.test(insertedPassword);
    let res1 =  /^[a-zA-Z0-9_.-]*$/.test(insertedPassword);
    if(insertedPassword.length < 1){
        msgContainer[key].push('*Required');
        msgContainer['isError'] = true;
    }
}
